import React, { FC } from 'react';
import { useQuery } from '@apollo/react-hooks';
import SimpleErrorBoundary from 'Jsx/Shared/ErrorBoundaries/Simple';

import customSessionStorage from 'Utils/customSessionStorage';

import useMe from 'Shared/Hooks/useMe';

import Loadable from 'Jsx/Shared/Loadable';

import { TopBannerGraphqlVariables } from '../../types';

import GET_BANNERS_QUERY from './graphql/Banner.graphql';

import { BannerType } from './types';
import { updateExpressFacebookLoginPosition } from '../../utils';

const TopBannerLazy: FC<{
  graphqlVariables: TopBannerGraphqlVariables;
}> = ({ graphqlVariables }) => {
  const { data, loading, error } = useQuery<
    { banners: BannerType[] },
    TopBannerGraphqlVariables
  >(GET_BANNERS_QUERY, {
    variables: graphqlVariables,
  });
  const { loading: loadingUserData } = useMe();

  React.useEffect(() => {
    if (!loading && data && data.banners && data.banners.length > 0) {
      const bannerVisibility = customSessionStorage.getItem('bannerVisibility');

      // we need to set a default value if bannerVisibility does not exists in the sessionStorage
      if (!bannerVisibility) {
        customSessionStorage.setItem('bannerVisibility', JSON.stringify(true));
      }
    } else {
      updateExpressFacebookLoginPosition();
    }
  }, [data, loading]);

  // for some reasons, data can be null after the requests has finished successfuly
  if (loadingUserData || loading || error || !data) {
    return null;
  }

  if (data && data.banners && data.banners.length === 0) {
    return null;
  }

  const isTopBannerHidden =
    customSessionStorage.getItem('bannerVisibility') === JSON.stringify(false);

  if (isTopBannerHidden) {
    return null;
  }

  return (
    <SimpleErrorBoundary>
      <Loadable
        module={() =>
          import(/* webpackChunkName: "main-menu-topBanner" */ './TopBanner')
        }
        name="TopBanner"
        banners={data.banners}
      />
    </SimpleErrorBoundary>
  );
};

export default TopBannerLazy;
